var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 14.5C30.8672 14.5 31.8047 15.0078 32.4297 15.75H35.125L37 17V18.25L33.25 19.1875V19.5V22C33.25 25.4375 30.9062 28.3672 27.7812 29.2266L29.4219 33.2109L29.9297 34.5391H27.8984L27.6641 33.9531L25.8672 29.5C25.8281 29.5 25.7891 29.5 25.75 29.5H24.1484L24.5781 30.5547L25.125 31.8828L25.6719 33.2109L26.1797 34.5H24.1484L23.9141 33.9531L23.3672 32.625L22.8203 31.2969L22.1172 29.5H16.9219L13.5234 32.1172L12 30.125L26.375 19.1094V17.9375C26.375 16.0625 27.8984 14.5 29.8125 14.5ZM29.8125 17C29.2656 17 28.875 17.4297 28.875 17.9375C28.875 18.4844 29.2656 18.875 29.8125 18.875C30.3203 18.875 30.75 18.4844 30.75 17.9375C30.75 17.4297 30.3203 17 29.8125 17Z",
    fill: "#111111",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/1_4.d4a89b1434680edaa4ed6551b70a44dc.svg";
export { ForwardRef as ReactComponent };